import { useSessionStore } from '@/entities/session';
import { formatHprd, HPRD_TOOLTIP, RATIO_TOOLTIP } from './hprd';

/**
 * Which staffing metric the signed-in organization sees: HPRD when its staff come from
 * Sling, the old Staffing Ratio otherwise.
 */
export const useStaffingMetric = () => {
  const isHprd = useSessionStore(
    (state) => state.user?.organization?.staffSource === 'SLING'
  );

  return {
    isHprd,
    title: isHprd ? 'Hours Per Resident Day' : 'Staffing Ratio',
    tooltip: isHprd ? HPRD_TOOLTIP : RATIO_TOOLTIP,
    /** Plain number for tables and charts (the "1:x" form stays with the old ratio). */
    formatNumber: (value: number | null | undefined) =>
      isHprd
        ? formatHprd(value)
        : value === null || value === undefined
          ? 'N/A'
          : value.toFixed(2),
  };
};
